const selectVPOCombinedActionsState = (state: any) =>
  state.vpoStrapi?.vpoCombinedActions || { data: [], loading: false, error: null, pagination: {} };

export const selectVPOCombinedActionsData = (state: any) =>
  selectVPOCombinedActionsState(state).data;

export const selectVPOCombinedActionsLoading = (state: any) =>
  selectVPOCombinedActionsState(state).loading;

export const selectVPOCombinedActionsError = (state: any) =>
  selectVPOCombinedActionsState(state).error;

export const selectVPOCombinedActionsPagination = (state: any) =>
  selectVPOCombinedActionsState(state).pagination;

export const selectVPOCombinedActionsHasNextPage = (state: any) =>
  selectVPOCombinedActionsPagination(state).hasNextPage || false;